import { BaseService } from '@common/http-layer/service/base.service'
import type { IProductDetail } from '../../types-layer/types/product'

export class ProductOfferService extends BaseService {
  constructor() {
    super({
      baseURL: 'REST_API_URLS',
      basePath: '/membership/offers/product',
    })
  }

  async getProductDataFromOffer(productId: string) {
    const { data } = await this.get<IProductDetail>(`/${productId}`)
    return data
  }
}
